// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Page_page__32mWb {\n  display: flex;\n}\n.Page_row__3LzSf {\n  flex-direction: row;\n}\n.Page_column__FN9wJ {\n  flex-direction: column;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Wrapper/Page.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".page {\n  display: flex;\n}\n.row {\n  flex-direction: row;\n}\n.column {\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "Page_page__32mWb",
	"row": "Page_row__3LzSf",
	"column": "Page_column__FN9wJ"
};
export default ___CSS_LOADER_EXPORT___;
